angular.module('app').component('traceSummary', {
    bindings: {},
    controllerAs: 'vm',
    controller: 'UtpTraceSummaryExController',
    templateUrl: 'scripts/app/partials/UtpTraceSummary/trace-summary.tpl.html'
});
